export default function(StudentPreferences, code) {
   const teachingPeriod = StudentPreferences.defaultTeachingPeriods.find((tp) => tp.code === code)
   if (teachingPeriod) {
     return teachingPeriod.label
   }
   return code
 }
